import { FC } from 'react';
import {
    MenuButtonBold,
    MenuButtonItalic,
    MenuButtonUnderline,
    MenuButtonStrikethrough,
    MenuButtonTextColor,
    MenuButtonHighlightColor,
    MenuButtonOrderedList,
    MenuButtonBulletedList,
    MenuButtonTaskList,
    MenuButtonBlockquote,
    MenuButtonCode,
    MenuButtonCodeBlock,
    MenuSelectHeading,
    MenuSelectTextAlign,
    MenuControlsContainer,
    MenuDivider,
} from 'mui-tiptap';

const EditorMenuControls: FC = () => {
    return (
        <MenuControlsContainer>
            {/* Encabezados */}
            <MenuSelectHeading />
            <MenuDivider />

            {/* Botones de formato de texto */}
            <MenuButtonBold />
            <MenuButtonItalic />
            <MenuButtonUnderline />
            <MenuButtonStrikethrough />
            <MenuDivider />

            {/* Botones de color de texto y resaltado */}
            <MenuButtonTextColor />
            <MenuButtonHighlightColor />
            <MenuDivider />

            {/* Listas y alineación */}
            <MenuButtonOrderedList />
            <MenuButtonBulletedList />
            <MenuButtonTaskList />
            <MenuDivider />
            <MenuSelectTextAlign />
            <MenuDivider />

            {/* Bloques de código y citas */}
            <MenuButtonBlockquote />
            <MenuButtonCode />
            <MenuButtonCodeBlock />
        </MenuControlsContainer>
    );
};

export default EditorMenuControls;
